import { render } from "./FornitoriContiAcquisto.vue?vue&type=template&id=61a9b47d&scoped=true"
import script from "./FornitoriContiAcquisto.vue?vue&type=script&lang=js"
export * from "./FornitoriContiAcquisto.vue?vue&type=script&lang=js"

import "./FornitoriContiAcquisto.vue?vue&type=style&index=0&id=61a9b47d&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a9b47d"]])

export default __exports__